export const DEFAULT_DATE_FORMATE = 'MM-dd-yyyy';
export const DEFAULT_API_URL = 'https://crh.medgre.com/medgre';
export const DEFAULT_LOCAL_PATH = '/mod';
export const COMMUNICATION_TAB = true;
export const CLINIC_NAME = 'Country Roads Healthcare LLC';
export const START_OF_WEEK = { weekStartsOn: 1 }; //=> 1=>Week start on Monday 0=>week starts on Sunday
export const VERSION = '1.4.38951.1';
